import React from 'react';
import '../styles/Input.scss';
import { blurOnEnter } from '../utils/keyboard';

const Input = ({
  type = 'text',
  placeholder = '',
  value = '',
  onChange,
  label,
  error,
  disabled = false,
  required = false,
  className = '',
  name = '',
}) => {
  return (
    <div className={`input-group ${className}`}>
      {label && (
        <label className="input-label">
          {label}
          {required && <span className="required">*</span>}
        </label>
      )}
      <input
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onKeyDown={blurOnEnter}
        disabled={disabled}
        name={name}
        className={`input-field ${error ? 'input-error' : ''}`}
      />
      {error && <span className="error-message">{error}</span>}
    </div>
  );
};

export default Input;
